export const TRIAL = 'trial';
export const FREE = 'free';
export const PRO = 'pro';
export const PAY_AS_YOU_GO = 'pay_as_you_go';
export const ENTERPRISE = 'enterprise';

export const PLAN_TYPES = { TRIAL, FREE, PRO, PAY_AS_YOU_GO, ENTERPRISE };
export const PLAN_TEXT: Record<string, string> = {
  [FREE]: 'Free',
  [TRIAL]: 'Trial',
  [PAY_AS_YOU_GO]: 'Serverless',
  [ENTERPRISE]: 'Enterprise',
  [PRO]: 'Pro',
};
